/**
 * TL Dashboard Sample Data
 * 
 * This file contains sample data to display when the backend returns no data,
 * empty data, or zero values. The sample data demonstrates how charts and
 * visualizations will look with real data.
 */

// ==================== USER STATISTICS SAMPLE DATA ====================

export const userStatisticsSampleData = {
    // User Growth Trend - Weekly (last 7 days)
    userGrowthTrendWeekly: [
        { label: 'Mon', users: 120 },
        { label: 'Tue', users: 132 },
        { label: 'Wed', users: 145 },
        { label: 'Thu', users: 150 },
        { label: 'Fri', users: 168 },
        { label: 'Sat', users: 175 },
        { label: 'Sun', users: 182 },
    ],

    // User Growth Trend - Monthly (last 4 weeks)
    userGrowthTrendMonthly: [
        { label: 'Week 1', users: 450 },
        { label: 'Week 2', users: 520 },
        { label: 'Week 3', users: 580 },
        { label: 'Week 4', users: 650 },
    ],

    // User Growth Trend - Yearly (last 12 months)
    userGrowthTrendYearly: [
        { label: 'Jan', users: 1200 },
        { label: 'Feb', users: 1350 },
        { label: 'Mar', users: 1520 },
        { label: 'Apr', users: 1680 },
        { label: 'May', users: 1850 },
        { label: 'Jun', users: 2020 },
        { label: 'Jul', users: 2180 },
        { label: 'Aug', users: 2350 },
        { label: 'Sep', users: 2520 },
        { label: 'Oct', users: 2700 },
        { label: 'Nov', users: 2880 },
        { label: 'Dec', users: 3050 },
    ],

    // Individual TL Footfall - Weekly
    individualFootfallWeekly: [
        { label: 'Mon', date: '2025-01-06', footfall: 45 },
        { label: 'Tue', date: '2025-01-07', footfall: 52 },
        { label: 'Wed', date: '2025-01-08', footfall: 38 },
        { label: 'Thu', date: '2025-01-09', footfall: 61 },
        { label: 'Fri', date: '2025-01-10', footfall: 55 },
        { label: 'Sat', date: '2025-01-11', footfall: 28 },
        { label: 'Sun', date: '2025-01-12', footfall: 15 },
    ],

    // Individual TL Footfall - Monthly
    individualFootfallMonthly: [
        { label: 'Week 1', date: '2025-01-01 to 2025-01-07', footfall: 245 },
        { label: 'Week 2', date: '2025-01-08 to 2025-01-14', footfall: 312 },
        { label: 'Week 3', date: '2025-01-15 to 2025-01-21', footfall: 278 },
        { label: 'Week 4', date: '2025-01-22 to 2025-01-28', footfall: 335 },
    ],

    // Individual TL Footfall - Yearly
    individualFootfallYearly: [
        { label: 'Jan 2025', date: '2025-01', footfall: 1250 },
        { label: 'Feb 2025', date: '2025-02', footfall: 1180 },
        { label: 'Mar 2025', date: '2025-03', footfall: 1420 },
        { label: 'Apr 2025', date: '2025-04', footfall: 1350 },
        { label: 'May 2025', date: '2025-05', footfall: 1580 },
        { label: 'Jun 2025', date: '2025-06', footfall: 1280 },
        { label: 'Jul 2025', date: '2025-07', footfall: 950 },
        { label: 'Aug 2025', date: '2025-08', footfall: 1120 },
        { label: 'Sep 2025', date: '2025-09', footfall: 1450 },
        { label: 'Oct 2025', date: '2025-10', footfall: 1380 },
        { label: 'Nov 2025', date: '2025-11', footfall: 1520 },
        { label: 'Dec 2025', date: '2025-12', footfall: 1650 },
    ],

    // Department Distribution
    departmentDistribution: [
        { department: 'CSE', count: 85, percentage: '34%' },
        { department: 'ME', count: 62, percentage: '24.8%' },
        { department: 'EE', count: 45, percentage: '18%' },
        { department: 'ECE', count: 32, percentage: '12.8%' },
        { department: 'CE', count: 18, percentage: '7.2%' },
        { department: 'Others', count: 8, percentage: '3.2%' },
    ],

    // Gender Stats
    genderStats: {
        male: 180,
        female: 70,
        male_percentage: '72%',
        female_percentage: '28%',
        male_this_period: 25,
        female_this_period: 12,
    },
};

// ==================== ENGAGEMENT SAMPLE DATA ====================

export const engagementSampleData = {
    // Peak Hours Analysis
    peakHoursAnalysis: [
        { time: '08:00', engagement: 12 },
        { time: '09:00', engagement: 28 },
        { time: '10:00', engagement: 45 },
        { time: '11:00', engagement: 52 },
        { time: '12:00', engagement: 38 },
        { time: '13:00', engagement: 48 },
        { time: '14:00', engagement: 55 },
        { time: '15:00', engagement: 42 },
    ],

    // Active Users Status
    activeUsersStatus: {
        active_users: 185,
        inactive_users: 65,
        active_percentage: '74%',
        inactive_percentage: '26%',
    },

    // Department Engagement
    departmentEngagement: [
        { department: 'CSE', engagement: 145 },
        { department: 'ME', engagement: 98 },
        { department: 'EE', engagement: 76 },
        { department: 'ECE', engagement: 62 },
        { department: 'CE', engagement: 45 },
        { department: 'Others', engagement: 24 },
    ],

    // Year-wise Engagement
    yearEngagement: [
        { year: '1st Year', total_visits: 120, unique_users: 45 },
        { year: '2nd Year', total_visits: 185, unique_users: 62 },
        { year: '3rd Year', total_visits: 210, unique_users: 78 },
        { year: '4th Year', total_visits: 165, unique_users: 55 },
        { year: '5th Year', total_visits: 85, unique_users: 28 },
    ],
};

// ==================== PROJECTS SAMPLE DATA ====================

export const projectsSampleData = {
    // Types of Projects
    typesOfProjects: [
        { type: 'Academic', count: 45 },
        { type: 'Research', count: 32 },
        { type: 'Personal', count: 28 },
        { type: 'Other', count: 15 },
    ],

    // Year-wise Distribution
    yearDistribution: [
        { year: '1st Year', students_involved: 120, projects: 18 },
        { year: '2nd Year', students_involved: 185, projects: 35 },
        { year: '3rd Year', students_involved: 210, projects: 42 },
        { year: '4th Year', students_involved: 145, projects: 22 },
        { year: '5th Year', students_involved: 85, projects: 8 },
    ],

    // Department-wise Projects
    departmentProjects: [
        { department: 'CSE', count: 38, avg_duration: 4.5 },
        { department: 'ME', count: 28, avg_duration: 6.2 },
        { department: 'EE', count: 22, avg_duration: 5.1 },
        { department: 'ECE', count: 18, avg_duration: 4.8 },
        { department: 'CE', count: 12, avg_duration: 5.5 },
        { department: 'Others', count: 7, avg_duration: 3.2 },
    ],

    // Trainings vs Quizzes
    trainingsVsQuizzes: {
        trainings_completed: 145,
        quizzes_solved: 102,
        total_workshops: 18,
        completion_rate: '70.3%',
        trend_data: [
            { label: 'Mon', trainings: 50, quizzes: 40 },
            { label: 'Tue', trainings: 90, quizzes: 55 },
            { label: 'Wed', trainings: 40, quizzes: 35 },
            { label: 'Thu', trainings: 35, quizzes: 30 },
            { label: 'Fri', trainings: 100, quizzes: 70 },
            { label: 'Sat', trainings: 85, quizzes: 30 },
            { label: 'Sun', trainings: 20, quizzes: 90 },
        ],
    },
};

// ==================== MACHINE USAGE SAMPLE DATA ====================

export const machineUsageSampleData = {
    // Most Used Machines
    mostUsedMachines: [
        { machine_name: '3D Printer', usage_hours: 156, period: 'weekly' },
        { machine_name: 'CNC Machine', usage_hours: 128, period: 'weekly' },
        { machine_name: 'Laser Cutter', usage_hours: 98, period: 'weekly' },
        { machine_name: 'Oscilloscope', usage_hours: 85, period: 'weekly' },
        { machine_name: 'Soldering Station', usage_hours: 72, period: 'weekly' },
        { machine_name: 'Multimeter', usage_hours: 54, period: 'weekly' },
    ],

    // Machine Status Overview
    machineStatusOverview: {
        operational: 42,
        under_maintenance: 8,
        out_of_order: 3,
        total_machines: 53,
        operational_percentage: '79.2%',
        under_maintenance_percentage: '15.1%',
        out_of_order_percentage: '5.7%',
    },

    // Most Issued Items
    mostIssuedItems: [
        { item_name: 'Arduino Uno', quantity: 85, period: 'weekly' },
        { item_name: 'Breadboard', quantity: 72, period: 'weekly' },
        { item_name: 'Jumper Wires', quantity: 150, period: 'weekly' },
        { item_name: 'Resistors (Pack)', quantity: 45, period: 'weekly' },
        { item_name: 'LEDs (Pack)', quantity: 38, period: 'weekly' },
        { item_name: 'Temperature Sensor', quantity: 28, period: 'weekly' },
    ],

    // Cost vs Usage
    costVsUsage: [
        { machine_name: '3D Printer', usage_hours: 156, cost: 85000 },
        { machine_name: 'CNC Machine', usage_hours: 128, cost: 150000 },
        { machine_name: 'Laser Cutter', usage_hours: 98, cost: 75000 },
        { machine_name: 'Oscilloscope', usage_hours: 85, cost: 25000 },
        { machine_name: 'Soldering Station', usage_hours: 72, cost: 8000 },
        { machine_name: 'Multimeter', usage_hours: 54, cost: 5000 },
        { machine_name: 'Power Supply', usage_hours: 45, cost: 12000 },
        { machine_name: 'Signal Generator', usage_hours: 32, cost: 35000 },
    ],

    // Machines Out of Order
    machinesOutOfOrder: [
        { machine_name: 'PCB Etching Machine', issue: 'Motor malfunction', downtime: '3 Days', status: 'Out of order' },
        { machine_name: 'Drill Press', issue: 'Belt replacement needed', downtime: '1 Day', status: 'Out of order' },
        { machine_name: 'Heat Gun', issue: 'Temperature sensor fault', downtime: '5 Days', status: 'Out of order' },
    ],
};

// ==================== MIS DATA SAMPLE DATA ====================

export const misDataSampleData = {
    // Types of Issues
    typesOfIssues: [
        { type: 'Login Issues', count: 28 },
        { type: 'Booking Problems', count: 22 },
        { type: 'Machine Not Working', count: 18 },
        { type: 'App Performance', count: 15 },
        { type: 'Record Updates', count: 12 },
        { type: 'Payment Issues', count: 8 },
        { type: 'Access Issues', count: 6 },
    ],

    // Issue Resolution Status
    issueResolutionStatus: {
        total_issues: 109,
        resolved: 72,
        in_progress: 25,
        pending: 12,
        resolved_percentage: '66.1%',
        in_progress_percentage: '22.9%',
        pending_percentage: '11%',
    },

    // Reported Issues by Category
    reportedIssuesByCategory: [
        { category: 'Technical', count: 42 },
        { category: 'Booking', count: 28 },
        { category: 'Account', count: 18 },
        { category: 'Equipment', count: 12 },
        { category: 'Access', count: 6 },
        { category: 'Others', count: 3 },
    ],

    // Recent Issues
    recentIssues: [
        {
            id: 1,
            title: 'Unable to login to the system',
            date: new Date().toISOString(),
            priority: 'High',
            status: 'Pending',
            category: 'Technical',
        },
        {
            id: 2,
            title: 'Machine booking confirmation not received',
            date: new Date().toISOString(),
            priority: 'Medium',
            status: 'In Progress',
            category: 'Booking',
        },
        {
            id: 3,
            title: '3D Printer calibration issue',
            date: new Date(Date.now() - 86400000).toISOString(),
            priority: 'High',
            status: 'In Progress',
            category: 'Equipment',
        },
        {
            id: 4,
            title: 'Update student department information',
            date: new Date(Date.now() - 86400000).toISOString(),
            priority: 'Low',
            status: 'Resolved',
            category: 'Account',
        },
        {
            id: 5,
            title: 'App crashes on dashboard load',
            date: new Date(Date.now() - 172800000).toISOString(),
            priority: 'High',
            status: 'Resolved',
            category: 'Technical',
        },
    ],
};

// ==================== UTILITY FUNCTIONS ====================

/**
 * Check if data is empty or contains only zero values
 * @param {any} data - Data to check
 * @param {string} type - Type of data check ('array', 'object', 'number')
 * @returns {boolean} - True if data is empty or zero
 */
export const isDataEmpty = (data, type = 'auto') => {
    if (data === null || data === undefined) return true;

    // Auto-detect type
    if (type === 'auto') {
        if (Array.isArray(data)) type = 'array';
        else if (typeof data === 'object') type = 'object';
        else if (typeof data === 'number') type = 'number';
        else return true;
    }

    switch (type) {
        case 'array':
            if (!Array.isArray(data) || data.length === 0) return true;
            // Check if all values in array are zero
            return data.every(item => {
                if (typeof item === 'object') {
                    const valueKeys = ['count', 'engagement', 'users', 'footfall', 'tl_footfall', 'user_count', 'usage_hours', 'quantity', 'total_visits', 'active_users', 'mis_logins', 'students_involved', 'projects'];
                    return valueKeys.every(key => !item[key] || item[key] === 0);
                }
                return item === 0;
            });

        case 'object':
            if (typeof data !== 'object' || Object.keys(data).length === 0) return true;
            const numericValues = Object.values(data).filter(v => typeof v === 'number');
            return numericValues.length > 0 && numericValues.every(v => v === 0);

        case 'number':
            return data === 0;

        default:
            return true;
    }
};

/**
 * Get sample data based on period for trend data
 * @param {string} dataType - Type of sample data needed
 * @param {string} period - Period: 'weekly', 'monthly', 'yearly'
 * @returns {any} - Sample data for the specified type and period
 */
export const getSampleDataForPeriod = (dataType, period = 'weekly') => {
    switch (dataType) {
        case 'userGrowthTrend':
            if (period === 'yearly') return userStatisticsSampleData.userGrowthTrendYearly;
            if (period === 'monthly') return userStatisticsSampleData.userGrowthTrendMonthly;
            return userStatisticsSampleData.userGrowthTrendWeekly;

        case 'individualFootfall':
            if (period === 'yearly') return userStatisticsSampleData.individualFootfallYearly;
            if (period === 'monthly') return userStatisticsSampleData.individualFootfallMonthly;
            return userStatisticsSampleData.individualFootfallWeekly;

        case 'departmentDistribution':
            return userStatisticsSampleData.departmentDistribution;

        case 'genderStats':
            return userStatisticsSampleData.genderStats;

        case 'peakHoursAnalysis':
            return engagementSampleData.peakHoursAnalysis;

        case 'activeUsersStatus':
            return engagementSampleData.activeUsersStatus;

        case 'departmentEngagement':
            return engagementSampleData.departmentEngagement;

        case 'yearEngagement':
            return engagementSampleData.yearEngagement;

        case 'typesOfProjects':
            return projectsSampleData.typesOfProjects;

        case 'yearDistribution':
            return projectsSampleData.yearDistribution;

        case 'departmentProjects':
            return projectsSampleData.departmentProjects;

        case 'trainingsVsQuizzes':
            return projectsSampleData.trainingsVsQuizzes;

        case 'mostUsedMachines':
            return machineUsageSampleData.mostUsedMachines;

        case 'machineStatusOverview':
            return machineUsageSampleData.machineStatusOverview;

        case 'mostIssuedItems':
            return machineUsageSampleData.mostIssuedItems;

        case 'costVsUsage':
            return machineUsageSampleData.costVsUsage;

        case 'machinesOutOfOrder':
            return machineUsageSampleData.machinesOutOfOrder;

        case 'typesOfIssues':
            return misDataSampleData.typesOfIssues;

        case 'issueResolutionStatus':
            return misDataSampleData.issueResolutionStatus;

        case 'reportedIssuesByCategory':
            return misDataSampleData.reportedIssuesByCategory;

        case 'recentIssues':
            return misDataSampleData.recentIssues;

        default:
            return null;
    }
};

const tlDashboardSampleData = {
    userStatisticsSampleData,
    engagementSampleData,
    projectsSampleData,
    machineUsageSampleData,
    misDataSampleData,
    isDataEmpty,
    getSampleDataForPeriod,
};